import { Controller } from "stimulus";

// Module-level variable to track the subscription and prevent duplicates.
// This controller is attached to the <body> element, which persists across
// Turbolinks navigations. This means disconnect() is never called during
// page transitions, so we cannot rely on it to clean up subscriptions.
// Using a module-level variable ensures only one subscription exists.
let subscription = null;

export default class extends Controller {
  static values = {
    userId: String
  }

  connect() {
    if (subscription) {
      return;
    }

    if (window.subscribeToNotificationsChannel) {
      subscription = window.subscribeToNotificationsChannel(this.userIdValue);
    }
  }
}
